import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'QUEST_CLIENT',
  title: 'Können meine Kunden sehen, mit wem ich zusammenarbeite?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Vertraulichkeit ist die Partnerschaft des Vertrauens, die OFA mit seinen Kunden hat. Keiner Ihrer Kunden kann sehen, mit wem Sie zusammengearbeitet haben oder bei wem Sie unter Vertrag stehen.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Diese Vertraulichkeit besteht nicht im Rahmen eines Projekts. Der Kunde Ihres Kunden kann auf Ihre Dokumente zugreifen.'
  }]
};
